/* eslint-disable react-hooks/exhaustive-deps */
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { Font } from "@react-pdf/renderer";
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../../../assets/fonts/rudawregular2.ttf';
import DriverPaymentService from '../../../../services/driverPaymentService';
import { useCompany } from '../../../../provider/companyProvider';
import { wrap } from 'comlink';



// ✅ Modern worker import (Webpack 5 / Vite)
const worker = new Worker(new URL('./pdfDriverPaymentListWorker.js', import.meta.url));
const workerApi = wrap(worker);

const registerFont = () => {
  Font.register({
    family: 'Rudaw',
    fonts: [{ src: Rudaw, fontWeight: 'normal' }],
  });
};

const PdfDriverPaymentList = ({ data }) => {
  const { i18n, t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const handlePrint = async () => {
    registerFont();
    setIsLoading(true);

    setIsLoading(true);
    const filters = data && {
      branchId: data.branch && data.branch.id,
      driverId: data.driver && data.driver.id,
      userId: data.user && data.user.id,
      ...data.time,
      sortBy: 'createdAt',
      order: 'asc'
    };

    try {
      // Fetch data
      const responseData = await DriverPaymentService.fetchAllPdf(filters);
      const { posts, totalAmount } = responseData;


      const translations = {
        driverPaymentList: t('driverPaymentList'),
        driver: t('driver'),
        branch: t('branch'),
        user: t('user'),
        duration: t('duration'),
        time: t('time'),
        startDate: t('startDate'),
        endDate: t('endDate'),
        currentDate: t('currentDate'),
        number: t('number'),
        id: t('id'),
        totalPriceAmount: t('totalPriceAmount'),
        invoiceNumber: t('invoiceNumber'),
        receiverPhone: t('receiverPhoneTable'),
        address: t('address'),
        totalPrice: t('totalPrice'),
        driverPrice: t('driverPrice'),
        netPrice: t('netPrice'),
        date: t('date'),
        note: t('note'),
        today: t('today'),
        week: t('week'),
        month: t('month'),
        custom: t('custom'),
        yesterday: t('yesterday'),
        daybeforeyesterday: t('daybeforeyesterday')
      };

      // Generate PDF
      const blobUrl = await workerApi.renderPDF({
        driver: data.driver,
        branch: data.branch,
        user: data.user,
        time: data.time,
        business,
        totalPrice: totalAmount,
        driverPayments: posts,
        t: translations,
        language: i18n.language,
      });
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading
    ? <CircularProgress size={20} />
    : <LocalPrintshopOutlinedIcon sx={{ cursor: 'pointer' }} fontSize='small' onClick={handlePrint} />;
};

export default PdfDriverPaymentList;